import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organizations/$organizationId/parent/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/organizations/$organizationId/parent/enrollment",
      params,
      replace: true,
    });
  },
});
